import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaymentStep} from '../../models/payment-step';
import {PaymentItemType} from '../../models/payment-type';

@Component({
  selector: 'tj-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss'],
})
export class PaymentStatusComponent implements OnInit {
  @Input() paymentStep: PaymentStep;
  @Input() orderData: any;
  @Input() error: any;
  @Input() itemType: PaymentItemType;
  @Input() items: any[] = [];
  @Output() backToPayment = new EventEmitter<void>();
  @Output() goBack = new EventEmitter<void>();

  ngOnInit() {
    console.log('Payment Status - Item Type:', this.itemType);
    console.log('Payment Status - Items:', this.items);
  }

  onBack() {
    window.history.back();
  }

  onBackToPayment() {
    this.backToPayment.emit();
  }
}
